module.exports = __webpack_public_path__ + "static/agoras-icon-0d0d5d2dfd91c68322ed103b16c3a8d6.svg";